import { XdsCoreButton } from './src/XdsCoreButton.js';

export { XdsCoreButton } from './src/XdsCoreButton.js';

const ElementRegistered = window.customElements.get('xds-core-button');

if (!ElementRegistered) {
  window.customElements.define('xds-core-button', XdsCoreButton as any);
}
